module.exports = __webpack_public_path__ + "media/customizations/smartlife/back-56f9feae3c3f2a3b52571db72c7abd36.jpg";